function RightSide(props) {
  return (
    <div className="new_company_settings_container-right_side">
      {props?.children}
    </div>
  );
}

export default RightSide;
